import { render } from "./ProfileMenuButton.vue?vue&type=template&id=6bceadc3&ts=true"
import script from "./ProfileMenuButton.vue?vue&type=script&lang=ts"
export * from "./ProfileMenuButton.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__